import SistemaServico from '@/portal/dominio/sistema/SistemaServico.js';

const api = SistemaServico.build({});

// Estado inicial
const state = {
    sistemas: [],
    perfis: []
};
// getters

const getters = {
    getPerfilPorSistema: state => sistema => state.perfis.find(perfil => perfil.nomeSistema === sistema),
    getSistemaPorArea: state => area => state.sistemas.find(sis => sis.codigoArea === area),
    getSistemaPorContexto: state => contexto => state.sistemas.find(sis => sis.contexto === contexto)
};

// actions
const actions = {
    carregarSistemas: (context) => {
        return api.listarSistemasArea().then(sistemas => context.commit('sistemas', sistemas));
    },
    carregarPerfisPadrao: (context) => {
        return api.listarPerfisPadrao().then(perfis => context.commit('perfis', perfis));
    },
    limparPerfisPadrao: (context) => context.commit('perfis', [])
};

// mutations
const mutations = {
    perfis: (state, perfis) => {
        state.perfis = perfis;
        if(state.sistemas.length && perfis.length){
            state.sistemas
                 .forEach(sis => {
                     sis.perfilPadrao = perfis.find(perfil => {
                        return perfil.nomeSistema === sis.nomeSistema;
                     });
                 });
        }
    },
    selecionarPerfil: (state, dados) => {
        dados.sistema.selecionarPerfil(dados.perfil);
    },
    sistemas: (state, sistemas) => {
        state.sistemas = sistemas;
        if(state.perfis.length){
            sistemas
                 .forEach(sis => {
                     sis.perfilPadrao = state.perfis.find(perfil => {
                        return perfil.nomeSistema === sis.nomeSistema;
                     });
                 });
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};